import React from 'react';
import { LanguageProvider } from './src/context/LanguageContext';
import { NotificationProvider } from './src/context/AddItemNotificationProvider';
import PageFade from './src/components/PageFade/PageFade';

export const wrapRootElement = ({ element }) => (
  <LanguageProvider>
    <NotificationProvider>{element}</NotificationProvider>
  </LanguageProvider>
);

// Crossfade each route change so navigation feels smooth instead of fragmented.
export const wrapPageElement = ({ element, props }) => (
  <PageFade location={props.location}>{element}</PageFade>
);
